import React, { useEffect, useState } from "react";
import { InputGroup, Image, Button } from "react-bootstrap";
import { FormControlSearch } from "../../../components";
import { isEmpty, isNull, get } from "lodash";
import { useFormikContext } from "formik";
import { getFilteredFunctionList } from "../../../utils";

const FunctionListSlider = ({
  index,
  data,
  objName,
  functionList,
  setOpenSlider,
  fieldName,
  sliderSize,
  setSliderSize,
}) => {
  const { setFieldValue } = useFormikContext();
  const returnDataType = get(data, "returnDataType", null);
  const [filteredData, setFilteredData] = useState(functionList);
  const [sliderData, setSliderData] = useState(null);
  const [saveSelectedData, setSaveSelectedData] = useState(null);
  const [knowMore, setKnowMore] = useState(
    functionList.map((_) => {
      return false;
    })
  );

  // useEffect(() => {
  //   setFilteredData(
  //     !isNull(returnDataType)
  //       ? functionList.filter((_) => _.returnDataType == returnDataType)
  //       : functionList
  //   );
  // }, [returnDataType]);

  const handleSearch = (name) => {
    if (name != "")
      setFilteredData(
        functionList.filter((_) =>
          _.name.toUpperCase().includes(name.toUpperCase())
        )
      );
    else setFilteredData(functionList);
  };

  const onHover = (idx) => {
    setKnowMore(
      knowMore.map((itm, i) => {
        if (i == idx) {
          return !itm;
        }
        return itm;
      })
    );
  };

  const onKnowMoreClick = (evt, item) => {
    evt.stopPropagation();
    setSaveSelectedData(item);
    setSliderData({
      name: item.name,
      description: item.sliderDescription,
      syntax: item.syntax,
      example: item.example,
    });
    !sliderSize && setSliderSize(!sliderSize);
  };

  const onSelectClick = (item) => {
    isNull(index)
      ? setFieldValue(`${objName}.value`, {
          // ...item,
          id: item.id,
          name: item.name,
          dataType: item.dataType,
          returnDataType: item.returnDataType,
          hasDynamicParameters: item.hasDynamicParameters ?? null,
          numberOfParameters: item.numberOfParameters,
          parameters: item?.parameters?.map((_) => {
            return {
              parameterType: 3,
              value: "",
              dataType: _.dataType,
              headerName: _.headerName,
            };
          }),
        })
      : setFieldValue(`${fieldName}.value`, {
          id: item.id,
          name: item.name,
          dataType: item.dataType,
          returnDataType: item.returnDataType,
          hasDynamicParameters: item.hasDynamicParameters ?? null,
          numberOfParameters: item.numberOfParameters,
          parameters: item?.parameters?.map((_) => {
            return {
              parameterType: 3,
              value: "",
              dataType: _.dataType,
              headerName: _.headerName,
            };
          }),
        });
    setOpenSlider(false);
  };

  return (
    <>
      <div className="d-flex">
        <div className={sliderSize ? "w-30" : "w-100"}>
          <p className="ft-14 fw-500 mb-3 mt-2">Select Function</p>
          <div className="border-line-seperator mb-3" />
          <InputGroup>
            <InputGroup.Prepend>
              <div className="passthrough-search-icon-postion">
                <i class="fal fa-search" aria-hidden="true"></i>
              </div>
            </InputGroup.Prepend>
            <FormControlSearch
              size="sm"
              id="source-search-box"
              type="text"
              screen={"passthrough"}
              placeholder="Select Functions here"
              className="source-search-box pl-5 p-3 w-100"
              autoComplete="off"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </InputGroup>

          <div className="function-list-container mt-2">
            {!isEmpty(filteredData) &&
              filteredData.map((item, idx) => {
                return (
                  <div
                    className="function-list cursor-pointer"
                    onMouseOver={() => onHover(idx)}
                    onMouseOut={() => onHover(idx)}
                    onClick={() => {
                      onSelectClick(item);
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <p className="ft-12 mb-1 fw-500">{item.displayedName}</p>
                      {knowMore[idx] ? (
                        <span
                          className="ft-10 link-text-mapper"
                          onClick={(evt) => onKnowMoreClick(evt, item)}
                        >
                          Know more
                        </span>
                      ) : (
                        <span />
                      )}
                    </div>
                    <p className="ft-10 mb-0">{item.description}</p>
                  </div>
                );
              })}
          </div>
        </div>
        {sliderSize && (
          <>
            <div className="border-vertical-line" />
            {sliderData && (
              <div className="w-70">
                <div className="d-flex justify-content-between align-items-baseline">
                  <p className="ft-14 fw-500 mb-3">{sliderData?.name}</p>
                  <div>
                    <Button
                      variant="secondary"
                      className="mr-2"
                      onClick={() => {
                        setOpenSlider(false);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        onSelectClick(saveSelectedData);
                      }}
                    >
                      Select
                    </Button>
                  </div>
                </div>

                <div className="border-line-seperator mb-3" />

                <div className="ft-14 fw-500 mb-1">Description</div>
                <p className="ft-12 mb-2">{sliderData?.description}</p>
                <div className="ft-14 fw-500 mb-1">Syntax</div>
                <p className="ft-12 mb-2"> {sliderData?.syntax}</p>
                <div className="ft-14 fw-500 mb-1">Example</div>
                <p className="ft-12 mb-2">{sliderData?.example} </p>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default FunctionListSlider;
